import { Action, Module, VuexModule } from "vuex-module-decorators";
import { HistoryExams } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class HistoryExamsModule extends VuexModule {
    @Action
    [HistoryExams.findPageHistoryExams](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/historyExams/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [HistoryExams.saveHistoryExams](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/historyExams/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [HistoryExams.deleteHistoryExams](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/historyExams/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}